import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';
import { ILabReqDTO, LoadType } from '@care-portals/api-interfaces';

import * as fromLabReq from './lab-req.reducer';
import * as LabReqSelectors from './lab-req.selectors';
import * as LabReqActions from './lab-req.actions';

@Injectable()
export class LabReqFacade {
  loading$ = this.store.pipe(select(LabReqSelectors.getLabReqLoading));
  saving$ = this.store.pipe(select(LabReqSelectors.getLabReqSaving));
  allLabReq$ = this.store.pipe(select(LabReqSelectors.getAllLabReq));
  selectedLabReq$ = this.store.pipe(select(LabReqSelectors.getSelected));

  constructor(private store: Store<fromLabReq.LabReqPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadLabReq(filters: any, loadType: LoadType = 'new') {
    this.dispatch(LabReqActions.loadLabReq({ loadType, filters }));
  }

  saveLabReq(labReq: ILabReqDTO) {
    this.dispatch(LabReqActions.saveLabReq({ labReq }));
  }

  updateLabReq(id: string, labReq: ILabReqDTO) {
    this.dispatch(LabReqActions.updateLabReq({ id, labReq }));
  }

  setActiveLabReq(id: string) {
    this.dispatch(LabReqActions.setActiveLabReqId({ labReqId: id }));
  }

  clearActiveLabReq() {
    this.dispatch(LabReqActions.clearActiveLabReqId());
  }

  loadLabReqPdfUrl(labReqId: string) {
    this.dispatch(LabReqActions.loadLabReqPdfUrl({ labReqId }));
  }
}
